import { postData, getData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';

// Fetch a single temporary URL (Best for PDFs or Doctor Signatures)
export const getSecureViewUrl = async (key) => {
  if (!key) return null;
  // If it's already a full URL (legacy data) or local blob, return it
  if (key.startsWith('blob:')) {
    return key;
  }
  
  try {
    const response = await getData(`${urlMap.images.privateViewUrl}?key=${encodeURIComponent(key)}`);
    // Assuming getData returns the data directly. Adjust if it returns { data: ... }
    return response.url || (response.data && response.data.url);
  } catch (error) {
    console.error('Failed to fetch secure URL', error);
    return null;
  }
};

const bulkCache = new Map();
const CACHE_TTL = 115 * 1000; // 1 min 55 seconds (slightly under 2 min to be safe)

// Fetch multiple temporary URLs at once (Best for Arrays of Assessment/Progress Images)
export const getBulkSecureViewUrls = async (keys) => {
  if (!keys || keys.length === 0) return {};
  
  const now = Date.now();
  const keysToFetch = [];
  const result = {};
  
  keys.forEach(k => {
    if (k.startsWith('blob:')) {
      result[k] = k;
    } else {
      const cached = bulkCache.get(k);
      if (cached && cached.expiresAt > now) {
        result[k] = cached.url;
      } else {
        keysToFetch.push(k);
      }
    }
  });

  if (keysToFetch.length === 0) return result;

  try {
    const response = await postData(urlMap.images.privateViewUrls, { keys: keysToFetch });
    const fetchedUrls = response.urls || (response.data && response.data.urls) || {};
    
    // Save to cache
    const expireTime = Date.now() + CACHE_TTL;
    Object.keys(fetchedUrls).forEach(k => {
      bulkCache.set(k, { url: fetchedUrls[k], expiresAt: expireTime });
      result[k] = fetchedUrls[k];
    });

    return result;
  } catch (error) {
    console.error('Failed to fetch bulk secure URLs', error);
    return result;
  }
};
